import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useTr } from '../contexts/LanguageContext';

const Footer = () => {
  const t = useTr();
  return (
    <footer className="relative py-12 sm:py-16"
      style={{ zIndex: 10, background: 'var(--sb-bg-1)', borderTop: '1px solid rgba(48,213,200,0.12)' }}
      data-testid="footer">
      <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '80%', height: 1, background: 'linear-gradient(90deg, transparent, rgba(48,213,200,0.4), transparent)', pointerEvents: 'none' }} />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 md:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 mb-10 sm:mb-12">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img src="/logo.svg" alt="SwarmBase" className="w-9 h-9 object-contain flex-shrink-0" />
              <span className="font-outfit font-black text-white tracking-tight text-lg">
                Swarm<span style={{ color: '#30d5c8' }}>Base</span>
              </span>
            </div>
            <p className="text-white/35 text-xs leading-relaxed max-w-xs">
              {t('Decentralized infrastructure for autonomous AI agent swarms. The cognitive backbone of the agentic era.',
                 '자율 AI 에이전트 스웜을 위한 탈중앙화 인프라입니다. 에이전트 시대의 인지 기반 구조.')}
            </p>
            <div className="flex items-center gap-2 mt-1">
              <Mail size={12} color="#30d5c8" />
              <a href="mailto:legal@swarmbase.io" className="text-white/30 hover:text-[#30d5c8] text-xs font-mono transition-colors">legal@swarmbase.io</a>
            </div>
            <p className="text-[#30d5c8]/20 text-xs font-mono">© 2026 SwarmBase</p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-white/40 text-xs font-mono tracking-widest uppercase mb-2">{t('Protocol', '프로토콜')}</p>
            {['SwarmCore', 'ComputeMesh', 'HiveMind', 'Proof of Swarm', 'SwarmBase SDK'].map((link) => (
              <a key={link} href="#architecture"
                onClick={(e) => { e.preventDefault(); document.getElementById('architecture')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="highlight-underline text-white/35 hover:text-[#30d5c8] text-sm transition-colors w-fit"
                data-testid={`footer-protocol-${link.replace(/\s+/g, '-').toLowerCase()}`}>
                {link}
              </a>
            ))}
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-white/40 text-xs font-mono tracking-widest uppercase mb-2">{t('Resources', '자료')}</p>
            <Link to="/whitepaper" className="highlight-underline text-white/35 hover:text-[#30d5c8] text-sm transition-colors w-fit" data-testid="footer-link-whitepaper">{t('Whitepaper', '백서')}</Link>
            <Link to="/privacy" className="highlight-underline text-white/35 hover:text-[#30d5c8] text-sm transition-colors w-fit" data-testid="footer-link-privacy">{t('Privacy Policy', '개인정보 처리방침')}</Link>
            <Link to="/terms" className="highlight-underline text-white/35 hover:text-[#30d5c8] text-sm transition-colors w-fit" data-testid="footer-link-terms">{t('Terms of Service', '이용약관')}</Link>
            <Link to="/disclaimer" className="highlight-underline text-white/35 hover:text-[#30d5c8] text-sm transition-colors w-fit" data-testid="footer-link-disclaimer">{t('Disclaimer', '면책 조항')}</Link>
          </div>
        </div>
        <div className="pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/20 text-xs font-mono">
            {t('SwarmBase — All rights reserved. Not financial advice.', 'SwarmBase — 모든 권리 보유. 재정적 조언이 아닙니다.')}
          </p>
          <p className="text-white/15 text-xs font-mono hidden sm:block">
            {t('Governed by the British Virgin Islands', '영국령 버진 아일랜드 법의 적용을 받습니다')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
